export default __webpack_public_path__ + "static/media/htb-mariana.8df56119.jpg";